import { render, staticRenderFns } from "./EditarElemento.vue?vue&type=template&id=1304c0b3"
import script from "./EditarElemento.vue?vue&type=script&lang=js"
export * from "./EditarElemento.vue?vue&type=script&lang=js"
import style0 from "./EditarElemento.vue?vue&type=style&index=0&id=1304c0b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports